import { styled, Stack, type StackProps } from '@mui/material'
import { ComponentType } from 'react'

type RecurrenceSettingsRootProps = StackProps

export const RecurrenceSettingsRoot = styled(Stack, {
  name: 'RecurrenceSettingsRoot',
})<RecurrenceSettingsRootProps>(({ theme: { spacing } }) => ({
  width: '100%',
  gap: spacing(3),
})) as ComponentType<RecurrenceSettingsRootProps>
